import { useEffect, useState } from "react";
import axios from "axios";
import Post from "../post/Post";
import Partilhar from "../partilhar/Partilhar";
import "./feed.css";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContex";

export default function Feed({ username }) {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const { user } = useContext(AuthContext);

  const [posts, setPost] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      const res = username
        ? await axios.get("post/perfil/" + username)
        : await axios.get("post/timeline/" + user._id);
      setPost(
        res.data.sort((p1, p2) => {
          return new Date(p2.createdAt) - new Date(p1.createdAt);
        })
      );
    };
    fetchPosts();
  }, [username, user._id]);

  return (
    <>
      {posts.map((p) => (
        <Post key={p._id} post={p} />
      ))}
    </>
  );
}
